import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecb8a704"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass('option-prefix')
}
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass('option-name')
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass('option-prefix')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_select = _resolveComponent("vue-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.isValid ? 'valid' : ''])
  }, [
    _createVNode(_component_vue_select, {
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.internalValue = $event)),
      options: _ctx.mappedCountries,
      placeholder: _ctx.placeholder,
      components: { OpenIndicator: _ctx.OpenIndicator },
      class: _normalizeClass(['wide-dropdown', _ctx.internalValue ? '' : 'not-selected']),
      "get-option-label": _ctx.getOptionLabel,
      disabled: _ctx.disabled,
      "filter-by": _ctx.filterBy,
      onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleLabelVisibility(true))),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleLabelVisibility(false)))
    }, {
      "selected-option": _withCtx(({ key, prefix }) => [
        key
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                class: _normalizeClass(`option-flag country-flag fi fi-${key.toLowerCase()}`)
              }, null, 2),
              _createElementVNode("span", _hoisted_1, _toDisplayString(prefix), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      option: _withCtx(({ key, prefix, name }) => [
        key
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", {
                class: _normalizeClass(`option-flag country-flag fi fi-${key.toLowerCase()}`)
              }, null, 2),
              _createElementVNode("span", _hoisted_2, _toDisplayString(name), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(prefix), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "options", "placeholder", "components", "class", "get-option-label", "disabled", "filter-by"]),
    _createElementVNode("span", {
      class: "custom-select__label",
      style: _normalizeStyle({ opacity: _ctx.isLabelVisible ? 1 : 0 })
    }, _toDisplayString(_ctx.label), 5)
  ], 2))
}